<template>
    <div class="rules-layout">
        <keep-alive include="RuleListView">
            <router-view />
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: 'RulesLayout',
}
</script>

<style lang="scss" scoped>
.rules-layout {
    width: 100%;
    height: 100%;
    background-color: $color-bg-new;
    overflow-y: auto;
}
</style>
